import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const StandardSearchField = ({ placeholder = 'Buscar', onEnter, ...props }) => {
  const { InputProps: incomingInputProps = {}, ...restProps } = props;

  return (
    <TextField
      size="small"
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        ...incomingInputProps,
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && typeof onEnter === 'function') {
          onEnter(e.currentTarget.value);
        }
      }}
      {...restProps}
    />
  );
};

export default StandardSearchField;
